import "core-js/modules/es.array.concat.js";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "regenerator-runtime/runtime.js";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _mutations, _actions;

import axios from 'axios';
import { API_FANS_BUY, API_VERIFY_CODE, API_FANS_BUY_PERFORMANCE } from '@/apis';
import { FANS_BUY, FANS_BUY_RESULT, PERFORMANCE_INFO, FANS_BUY_PERFORMANCE, VERIFY_CODE } from '@/constants/fansBuy';
import Drip from 'drip';
var sellChannel = (Drip.constant || {}).appType;
export default {
  state: {
    fansBuyResult: [],
    performanceInfo: {}
  },
  mutations: (_mutations = {}, _defineProperty(_mutations, FANS_BUY_RESULT, function (state, payload) {
    state.questionList = payload;
  }), _defineProperty(_mutations, FANS_BUY_PERFORMANCE, function (state, payload) {
    state.performanceInfo = payload;
  }), _mutations),
  actions: (_actions = {}, _defineProperty(_actions, FANS_BUY, function (_ref, _ref2) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var commit, state, uniqueCode, userName, mobile, idNumber, smsCode, value;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              commit = _ref.commit, state = _ref.state;
              uniqueCode = _ref2.uniqueCode, userName = _ref2.userName, mobile = _ref2.mobile, idNumber = _ref2.idNumber, smsCode = _ref2.smsCode;
              _context.next = 4;
              return axios.get("".concat(API_FANS_BUY).concat(uniqueCode, "?userName=").concat(userName, "&mobile=").concat(mobile).concat(idNumber ? '&idNumber=' + idNumber : '').concat(smsCode ? '&smsCode=' + smsCode : '')).then(function (_ref3) {
                var code = _ref3.code,
                    data = _ref3.data,
                    msg = _ref3.msg;
                commit(FANS_BUY_RESULT, data);
                return {
                  code: code,
                  data: data,
                  msg: msg
                };
              }).catch(function (err) {
                console.warn(err);
              });

            case 4:
              value = _context.sent;
              return _context.abrupt("return", value);

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  }), _defineProperty(_actions, PERFORMANCE_INFO, function (_ref4, _ref5) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var commit, state, uniqueCode, value;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              commit = _ref4.commit, state = _ref4.state;
              uniqueCode = _ref5.uniqueCode;
              _context2.next = 4;
              return axios.get("".concat(API_FANS_BUY_PERFORMANCE).concat(uniqueCode)).then(function (_ref6) {
                var code = _ref6.code,
                    data = _ref6.data,
                    msg = _ref6.msg;
                commit(FANS_BUY_PERFORMANCE, data);
                return {
                  code: code,
                  data: data,
                  msg: msg
                };
              }).catch(function (err) {
                console.warn(err);
              });

            case 4:
              value = _context2.sent;
              return _context2.abrupt("return", value);

            case 6:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  }), _defineProperty(_actions, VERIFY_CODE, function (_ref7, _ref8) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      var commit, state, uniqueCode, userName, mobile, idNumber, smsCode, value;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              commit = _ref7.commit, state = _ref7.state;
              uniqueCode = _ref8.uniqueCode, userName = _ref8.userName, mobile = _ref8.mobile, idNumber = _ref8.idNumber, smsCode = _ref8.smsCode;
              _context3.next = 4;
              return axios.get("".concat(API_VERIFY_CODE).concat(uniqueCode, "?userName=").concat(userName, "&mobile=").concat(mobile).concat(idNumber ? '&idNumber=' + idNumber : '')).then(function (_ref9) {
                var code = _ref9.code,
                    data = _ref9.data,
                    msg = _ref9.msg;
                commit(FANS_BUY_RESULT, data);
                return {
                  code: code,
                  data: data,
                  msg: msg
                };
              }).catch(function (err) {
                console.warn(err);
              });

            case 4:
              value = _context3.sent;
              return _context3.abrupt("return", value);

            case 6:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }))();
  }), _actions),
  getters: {
    performanceInfo: function performanceInfo(state) {
      return state.performanceInfo;
    }
  }
};